import { create } from "../../../../../common/utils/zustand_state_manager";
import {
  InitializePaginationProperties,
  InitializeSetPaginationProperties,
  PaginationProperties,
  SetPaginationProperties,
} from "../../../../../common/utils/pagination_property";

type State = PaginationProperties;
type Actions = SetPaginationProperties;

export const useControleAguaListaPagination = create<State & Actions>((set) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));
